<script setup>
import BreezeInput from '@/Components/Input.vue';
import LangingLayout from '@/Layouts/Layout.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import { __ } from '@/app';
import LayoutNew from '@/Layouts/LayoutNew.vue';
import FormHeader from '@/Components/FormHeader.vue';
import SubmitButton from '@/Components/SubmitButton.vue';

defineProps({
    canResetPassword: Boolean,
    status: String,
});

// Access the translations prop from the Inertia page object
// const translations = computed(() => usePage().props.value.translations);

const form = useForm({
    email: '',
    password: '',
    remember: false
});

const submit = () => {
    form.post(route('login'), {
        onFinish: () => form.reset('password'),
    });
};

// document.getElementById("loginForm").addEventListener("submit", function (e) {
// e.preventDefault(); // Prevent form submission

// let email = document.getElementById("email").value;
// let password = document.getElementById("password").value;
// let emailError = document.getElementById("emailError");
// let passwordError = document.getElementById("passwordError");
// let isValid = true;

// // Reset error messages
// emailError.textContent = "";
// passwordError.textContent = "";

// // Email validation
// if (!email) {
// emailError.textContent = "Email is required.";
// isValid = false;
// } else if (!/\S+@\S+\.\S+/.test(email)) { // Basic email format validation
// emailError.textContent = "Please enter a valid email address.";
// isValid = false;
// }

// // Password validation
// if (!password) {
// passwordError.textContent = "Password is required.";
// isValid = false;
// } else if (password !== "correctpassword") { // Example incorrect password check
// passwordError.textContent = "Incorrect password.";
// isValid = false;
// }

// // If form is valid, submit form or proceed with other actions
// if (isValid) {
// // Here, handle successful validation, like sending data to the server
// alert("Form is valid and ready for submission!");
// }
// });
</script>

<template>
    <LayoutNew>
        <Head v-bind:title="__('Log in')" />

        <div style="max-width: 450px; width: 100%;">            

            <FormHeader v-bind:title="__('Zaloguj się')"/>

            <div>
                <BreezeValidationErrors class="mb-4 alert alert-danger" />
                <div v-if="status" class="mb-4 alert alert-info">asdliasud ioasud {{ status }}</div>
                <form @submit.prevent="submit">
                    <div class="mb-2">
                        <label for="email" class="form-label" v-text="__( 'Adres Email' )"/>
                        <BreezeInput v-bind:placeholder="__('Wprowadź swój adres e-mail')" id="email" type="email" v-model="form.email" required autofocus autocomplete="username" />
                        <div class="error" id="emailError"></div>
                    </div>
                    <div class="mb-2">
                        <label for="password" class="form-label" v-text="__('Hasło')"/>
                        <BreezeInput v-bind:placeholder="__('Wprowadź swoje hasło')" id="password" type="password" v-model="form.password" required autocomplete="current-password" />
                        <div class="error" id="passwordError"></div>
                    </div>

                    <SubmitButton v-bind:text="__( 'Zaloguj się' )" />

                    <div class="text-center mt-2">
                        <p><Link v-if="canResetPassword" :href="route('password.request')"  v-text="__( 'Zapomniałeś hasła?' )"/></p>
                        <p>&mdash; {{ __( 'albo' ) }} &mdash;</p>
                        <p>
                            {{ __('Nie masz konta?') }} <Link :href="route('register')"  v-text="__( 'Zarejestruj się' )"/>
                        </p>
                    </div>
                </form>                
            </div>
        </div>
    
 
    </LayoutNew>
</template>
<style>
.error {
    color: red;
    font-size: 0.9em;
}
</style>